const ReportData = {
    overview: [
      { name: "Customer", number: 1000, percent: -15 },
      { name: "Orders", number: 1050, percent: +20 },
      { name: "Revenue", number: "$50,000", percent: +10 },
      { name: "Net Profit", number: "$12,000", percent: +12 },
    ],
    orderHead: { num: 'No.', item: "Item", quantity: 'Quantity', revenue: 'Revenue', profit: 'NetProfit' },
    order: [
      { num: 1, item: "Sashmi", quantity: 30, revenue: 293.01, profit: 710.68 },
      {
        num: 2,
        item: "Unagi- Grilled Eel",
        quantity: 30,
        revenue: 793.01,
        profit: 770.68,
      },
      {
        num: 3,
        item: "Soba- Buckwheat Noodles",
        quantity: 30,
        revenue: 273.01,
        profit: 110.68,
      },
      {
        num: 4,
        item: "Onigiri- Rice Balls",
        quantity: 25,
        revenue: 873.01,
        profit: 510.68,
      },
      {
        num: 5,
        item: "Yakitori- Grilled Chicken",
        quantity: 40,
        revenue: 573.01,
        profit: 210.68,
      },
      {
        num: 6,
        item: "Royal Milk Tea",
        quantity: 40,
        revenue: 573.01,
        profit: 210.68,
      },
      {
        num: 7,
        item: "Flavoured Soya Milk",
        quantity: 30,
        revenue: 673.01,
        profit: 280.68,
      },
    ],
    sold: [
      { num: 1, item: "Sashmi", quantity: 430 },
      { num: 2, item: "Unagi- Grilled Eel", quantity: 200 },
      { num: 3, item: "Soba- Buckwheat Noodles", quantity: 180 },
      { num: 4, item: "Onigiri- Rice Balls", quantity: 25 },
      { num: 5, item: "Yakitori- Grilled Chicken", quantity: 120 },
      { num: 6, item: "Royal Milk Tea", quantity: 80 },
      { num: 7, item: "Flavoured Soya Milk", quantity: 70 },
    ],
  };

export default ReportData